angular.module("ainapp")
    .controller("stockVoucherTrashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Stock Voucher Trash";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {


                            if ($scope.selectedVoucher.NameVal == "Opening Stock") {
                                MainService.DeletedOpeningStocks(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Stock Receive") {
                                MainService.DeletedStockReceives(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Stock Issue") {
                                MainService.DeletedStockIssues(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Stock FOC") {
                                MainService.DeletedStockFCOs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Stock JV") {
                                MainService.DeletedStockJVs(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else {
                                o.success({
                                    Data: [],
                                    Total: 0
                                });
                            }


                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                UpdatedDate: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },


                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "UpdatedBy.UserName": {
                                    type: "string",
                                },
                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "VoucherNumber",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },

                        {
                            field: "CreatedBy.UserName",
                            title: "Created By",
                            width: "100px"
                    },
                        {
                            field: "CreatedDate",
                            template: "<p> {{dataItem.CreatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Created Date",
                            width: "100px"
                    },
                        {
                            field: "UpdatedBy.UserName",
                            title: "Updated By",
                            width: "100px"
                    },
                        {
                            field: "UpdatedDate",
                            template: "<p> {{dataItem.UpdatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Updated Date",
                            width: "100px"
                    },

                  ],
                };


            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VArray = [];

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    var temp50 = {
                        Id: 50,
                        Name: "Opening Stock",
                        NameVal: "Opening Stock"
                    };
                    if ($scope.CompanyProfile.OpeningStock != "" & $scope.CompanyProfile.OpeningStock != null) {
                        temp50.Name = $scope.CompanyProfile.OpeningStock;
                    }
                    $scope.VArray.push(temp50);

                    var temp51 = {
                        Id: 51,
                        Name: "Stock Receive",
                        NameVal: "Stock Receive"
                    };
                    if ($scope.CompanyProfile.StockReceive != "" & $scope.CompanyProfile.StockReceive != null) {
                        temp51.Name = $scope.CompanyProfile.StockReceive;
                    }
                    $scope.VArray.push(temp51);

                    var temp52 = {
                        Id: 52,
                        Name: "Stock Issue",
                        NameVal: "Stock Issue"
                    };
                    if ($scope.CompanyProfile.StockIssue != "" & $scope.CompanyProfile.StockIssue != null) {
                        temp52.Name = $scope.CompanyProfile.StockIssue;
                    }
                    $scope.VArray.push(temp52);

                    var temp53 = {
                        Id: 53,
                        Name: "Stock FOC",
                        NameVal: "Stock FOC"
                    };
                    if ($scope.CompanyProfile.StockFOC != "" & $scope.CompanyProfile.StockFOC != null) {
                        temp53.Name = $scope.CompanyProfile.StockFOC;
                    }
                    $scope.VArray.push(temp53);

                    var temp55 = {
                        Id: 55,
                        Name: "Stock JV",
                        NameVal: "Stock JV"
                    };
                    if ($scope.CompanyProfile.StockJV != "" & $scope.CompanyProfile.StockJV != null) {
                        temp55.Name = $scope.CompanyProfile.StockJV;
                    }
                    $scope.VArray.push(temp55);

                    $scope.selectedVoucher = $scope.VArray[0];
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");

                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.refresh = function () {
                $scope.selectedVoucher = $scope.VArray[0];
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.changeView = function (data) {
                $scope.selectedVoucher = data;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


                }])
